export const AVATARS = {
  fox: "🦊", owl: "🦉", cat: "🐱", panda: "🐼", dino: "🦖", bear: "🐻", rabbit: "🐰", lion: "🦁",
  penguin: "🐧", monkey: "🐵", tiger: "🐯", frog: "🐸", unicorn: "🦄", dragon: "🐉", robot: "🤖", alien: "👽",
};

export const EXERCISE_TYPES = {
  technisch_lezen: { label: "Technisch lezen", icon: "BookOpen", color: "teal" },
  begrijpend_lezen: { label: "Begrijpend lezen", icon: "BookOpen", color: "blue" },
  voorspellen: { label: "Voorspellen", icon: "Sparkles", color: "purple" },
  gatentekst: { label: "Gatentekst", icon: "PencilLine", color: "green" },
  minitoets: { label: "Minitoets", icon: "ClipboardCheck", color: "amber" },
  cito_toets: { label: "Cito-toets (op tijd)", icon: "Timer", color: "orange" },
};

export const GROEPS = [3, 4, 5, 6, 7, 8];
export const PHASES = [
  { id: "B", label: "Begin" },
  { id: "M", label: "Midden" },
  { id: "E", label: "Eind" },
];

const _PHASE_NAME = { B: "Begin", M: "Midden", E: "Eind" };
export const DIFFICULTIES = (() => {
  const m = { groep4: "Groep 4", groep6: "Groep 6" };
  GROEPS.forEach((g) => ["B", "M", "E"].forEach((p) => { m[`${p}${g}`] = `${_PHASE_NAME[p]} groep ${g}`; }));
  return m;
})();

export const SKILL_LABELS = {
  hoofdgedachte: "Hoofdgedachte",
  woordenschat: "Woordenschat",
  gevolgtrekking: "Gevolgtrekking",
  oorzaak_gevolg: "Oorzaak & gevolg",
  verwijswoorden: "Verwijswoorden",
  samenvatting: "Samenvatting",
  voorspelling: "Voorspelling",
};

export const THEMES = ["Dieren", "Ruimte", "Avontuur", "Sport", "Natuur", "Geschiedenis", "Wetenschap", "Sprookjes"];

export const THEMES_BY_GROEP = {
  3: ["Dieren", "Sprookjes", "Avontuur", "Natuur"],
  4: ["Dieren", "Sprookjes", "Avontuur", "Natuur", "Sport"],
  5: ["Dieren", "Ruimte", "Avontuur", "Sport", "Natuur", "Sprookjes"],
  6: ["Dieren", "Ruimte", "Avontuur", "Sport", "Natuur", "Sprookjes"],
  7: ["Dieren", "Ruimte", "Avontuur", "Sport", "Natuur", "Geschiedenis", "Wetenschap"],
  8: ["Ruimte", "Avontuur", "Sport", "Natuur", "Geschiedenis", "Wetenschap", "Dieren"],
};

export const SUBJECTS = {
  lezen: { label: "Lezen", emoji: "📖", icon: "BookOpen", desc: "Begrijpend lezen" },
  rekenen: { label: "Rekenen", emoji: "🔢", icon: "Calculator", desc: "Sommen & getallen" },
};

export const MATH_EXERCISE_TYPES = {
  optellen_aftrekken: { label: "Optellen & aftrekken", icon: "Plus" },
  tafels: { label: "Tafels (× en ÷)", icon: "Grid3x3" },
  sorteren: { label: "Sleep & sorteer", icon: "ListOrdered" },
  matchspel: { label: "Combineerspel", icon: "Puzzle" },
  breuken: { label: "Breuken", icon: "PieChart" },
  kommagetallen: { label: "Kommagetallen", icon: "Hash" },
  procenten: { label: "Procenten", icon: "Percent" },
  verhoudingen: { label: "Verhoudingen", icon: "Scale" },
  meetkunde: { label: "Meetkunde", icon: "Shapes" },
  klok_geld_meten: { label: "Klok, geld & meten", icon: "Clock" },
  verhaaltjessommen: { label: "Verhaaltjessommen", icon: "ScrollText" },
  reken_cito: { label: "Cito-rekentoets (op tijd)", icon: "Timer" },
};

export const MATH_SKILL_LABELS = {
  optellen_aftrekken: "Optellen & aftrekken",
  vermenigvuldigen: "Vermenigvuldigen",
  delen: "Delen",
  breuken: "Breuken",
  kommagetallen: "Kommagetallen",
  procenten: "Procenten",
  verhoudingen: "Verhoudingen",
  meetkunde: "Meetkunde",
  klokkijken: "Klokkijken",
  geld: "Geld",
  meten: "Meten",
  verhaaltjessommen: "Verhaaltjessommen",
};
